/* r12: only the new hero 3-pack form. Existing 12-pack/Recon code is unchanged. */
(() => {
  'use strict';
  if (customElements.get('aa-hero-recon-order')) return;
  class AAHeroReconOrder extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      if (!this.querySelector('[data-hero-recon-details]')) {
        clearTimeout(this._childrenTimer);
        this._childrenTimer = setTimeout(() => { if (this.isConnected) this.connectedCallback(); }, 0);
        return;
      }
      this.form = this.querySelector('form');
      this.select = this.querySelector('[name="id"]');
      this.quantity = this.querySelector('[name="quantity"]');
      this.buy = this.querySelector('[type="submit"]');
      this.note = this.querySelector('[role="status"]');
      this.details = this.querySelector('[data-hero-recon-details]');
      this.scope = this.closest('#page');
      if (!this.form || !this.select || !this.quantity || !this.buy || !this.note || !this.scope) return;
      this._connected = true;
      this._abort = new AbortController();
      const events = { signal: this._abort.signal };
      this.options = [...this.select.options].filter(option => option.dataset.flavor);
      this.scope.addEventListener('click', event => {
        const button = event.target.closest?.('[data-fbtn]');
        if (button && this.scope.contains(button)) this.sync();
      }, events);
      this.form.addEventListener('submit', event => {
        // Re-read the actual active hero flavor at submission; never fall back
        // to the other flavor, or to a 12-pack if the requested 3-pack is unavailable.
        if (!this.sync() || !this.form.reportValidity()) event.preventDefault();
        // Native POST /{locale}/cart/add. Shopify remains authoritative for stock.
      }, events);
      this.classList.add('is-enhanced');
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this._childrenTimer);
      this._abort?.abort();
      this._connected = false;
      this.classList.remove('is-enhanced');
    }
    sync() {
      const active = this.scope.querySelector('.heroMedia [data-fbtn][aria-pressed="true"]');
      const flavor = active?.dataset.fbtn || 'bo';
      const option = this.options.find(item => item.dataset.flavor === flavor);
      const ready = !!option && !option.disabled && option.dataset.state === 'ready' && !!option.value;
      const name = flavor === 'sl' ? 'Slayberry' : 'Boujee Berry';
      this.select.disabled = !ready;
      this.select.value = ready ? option.value : '';
      this.quantity.value = '1';
      this.quantity.disabled = !ready;
      this.buy.disabled = !ready;
      this.buy.textContent = ready ? 'Add 3-Pack to Cart' : option?.dataset.state === 'soldout' ? '3-Pack Sold Out' : '3-Pack Unavailable';
      this.note.textContent = ready ? `${name} · ${option.dataset.price} · 3 bottles`
        : option?.dataset.state === 'quantity-rule' ? `${name} requires a different pack quantity.`
        : option?.dataset.state === 'soldout' ? `${name} 3-pack is sold out.` : `${name} 3-pack is temporarily unavailable.`;
      this.details.hidden = ready;
      return ready;
    }
  }
  customElements.define('aa-hero-recon-order', AAHeroReconOrder);
})();
